import CLIENT from '../utils/restClient';
import Logger, {LOG_LEVELS, ERRORS, ALL_MESSAGES} from '../utils/logger';
import deep from 'deep-diff';
import JSON_TRANSFORM from '../utils/jsonTransform/jsonTransformers';
import xml2js from 'xml2js';

export const MODULE_NAME = 'TRANSACTION_EDIT_CONTROLLER';
const log = new Logger(MODULE_NAME, LOG_LEVELS.DEBUG);

function namespaced(name) {
  return MODULE_NAME+'.'+name;
}

const LOAD = namespaced('LOAD');
const LOAD_OK = namespaced('LOAD_OK');
const LOAD_FAIL = namespaced('LOAD_FAIL');
const UPDATE = namespaced('UPDATE');
const UPDATE_PROGRESS = namespaced('UPDATE_PROGRESS');
const UPDATE_OK = namespaced('UPDATE_OK');
const UPDATE_FAIL = namespaced('UPDATE_FAIL');


export const ACTION_TYPES = {
  LOAD,
  LOAD_OK,
  LOAD_FAIL,
  UPDATE,
  UPDATE_PROGRESS,
  UPDATE_OK,
  UPDATE_FAIL,
};

// In redux parlance, this is a reducer
export const updateSubStateFromAction = (state = {data: undefined, loading: false, error: null}, action) => {
  log.debug('updateSubStateFromAction: ', action, state );
  const getNewState = (action, state) => {
    switch (action.type) {
      case LOAD:
        return  Object.assign({}, state, {loading: true, error: null});
      case LOAD_OK:
        return Object.assign({}, state, {data: action.response, loading: false, error: null, progress: undefined});
      case LOAD_FAIL:
        return Object.assign({}, state, {data: undefined, loading: false, error: action.error});
      case UPDATE:
        return  Object.assign({}, state, {loading: true, error: null, progress: action.progress});
      case UPDATE_PROGRESS:
        return  Object.assign({}, state, {error: null, progress: action.progress});
      case UPDATE_OK:
        return Object.assign({}, state, {data: undefined, loading: false, error: null});
      case UPDATE_FAIL:
        return Object.assign({}, state, {loading: false, failures: action.failures});
      default:
        return state;
    }
  };
  const newState = getNewState(action, state);
  log.debug('updateSubStateFromAction:  newState', newState );
  return newState;
};

function clearErrors() {  
  log.clearDictionaryError(ERRORS.TRANSACTION_REDELIVER_ERROR);
}

function getTransactionDataSummary(transactionDetails={}) {
  let documentJson = (transactionDetails.structured && transactionDetails.structured.documentJson) || {};
  let invoiceProps = (documentJson.ReportingDocument && documentJson.ReportingDocument.InvoiceProperties) || {};
  let supplierData = invoiceProps.SupplierData || {};
  let invoiceNumber = invoiceProps.InvoiceNumber || '';
  let country = supplierData.Country || '';
  let companyCode = supplierData.UserID || '';
  let matchedCompany = (transactionDetails.companies && transactionDetails.companies.find((company) => company.code == companyCode));
  return {
    invoiceNumber: invoiceNumber,
    country: country,
    companyCode: companyCode,
    companyDetails: matchedCompany,
  };
}

export const API = {
  doClearErrors: () => {
    return (dispatch, getState) =>{
      clearErrors();
    };
  },
  doLoad: (id) => {
    return (dispatch, getState) => {
      dispatch({type: LOAD});
      log.debug('doLoad():', id);
      CLIENT.getReportingDocumentXML(id)
        .then((response) => {
          log.debug('doLoad(): succeeded: ', response);
          dispatch({type: LOAD_OK, response: response});          
        })
        .catch((error) => {
          //Clear any existing errors
          clearErrors();
          log.debug('doLoad(): failed: ', error);
          dispatch({type: LOAD_FAIL, error});
        });
    }
  },
  doAction: (formData, action, id, reason) => {
    log.debug('doAction: formData: ', formData);

    // If something changed, find out what
    if(formData.changed){
      log.debug('doAction: data was changed');

      const whatChanged = deep(formData.initialValues, formData.fieldValues) || [];
      log.debug('doAction: this Changed: ', whatChanged);

      let changesList = [];
      whatChanged.map((diffItem, index) => {
        let itemCurrentValue = diffItem.lhs;
        let itemNewValue = diffItem.rhs;
        let jsonPath = JSON_TRANSFORM.arrayToFlatReference(diffItem.path);
        let shortPath = jsonPath.substring(jsonPath.indexOf("ReportingDocument"));

        let change = {
          "tagName" : shortPath,
          "oldValue": itemCurrentValue,
          "newValue": itemNewValue
        };

        changesList.push(change);
        log.debug('doAction change ', change);
        log.debug('doAction changes ', changesList);
      });

      // Convert the current state from structured object back to XML
      let builder = new xml2js.Builder({rootName: 'ReportingDocument', headless:true, renderOpts: {'pretty': false}});
      let xmlReportingDocument = builder.buildObject(formData.structured.documentJson.ReportingDocument);
      let body = { "xml": xmlReportingDocument, "changeLog": changesList , "reason": reason };

      return (dispatch, getState) => {
        dispatch({type: UPDATE});
        clearErrors();
        log.clearSuccessMessage(ALL_MESSAGES.TRANSACTION_ACTION_SUCCESS);
        CLIENT.doActionOnTransactionWithChanges(action, [id], body)
          .then((response) => {
            log.debug('doAction doActionOnTransactionWithChanges: ', response);
            log.setDictionaryMessage(ALL_MESSAGES.TRANSACTION_ACTION_SUCCESS, (action === 'forceToError'? 'force to error' : action));
            dispatch({type: UPDATE_OK, response: response});            
          })
          .catch((error) => {
            log.debug('doAction doActionOnTransactionsWithChanges: ', error);
            if(error.status === 409) {
              //Get errorData
              const errorData = error.errorData;
              if(Array.isArray(errorData) && errorData.length > 0) {
                errorData.forEach( e => {
                  log.setDictionaryMessage(ERRORS.TRANSACTION_REDELIVER_ERROR ,  e.failure); 
                });
              }
            }
            dispatch({type: UPDATE_FAIL, error});
          });
      };

    } else {
      // No changes so it's a straight redeliver/forceToError

      return (dispatch, getState) => {
        dispatch({type: UPDATE});
        clearErrors();
        log.clearSuccessMessage(ALL_MESSAGES.TRANSACTION_ACTION_SUCCESS);
        CLIENT.doActionOnTransactions(action, [id], reason, getTransactionDataSummary(formData))
          .then((response) => {
            log.debug('doAction doActionOnTransactions: ', response);            
            dispatch({type: UPDATE_OK, response: response});
            log.setDictionaryMessage(ALL_MESSAGES.TRANSACTION_ACTION_SUCCESS, (action === 'forceToError'? 'force to error' : action));
          })
          .catch((error) => {
            log.debug('doAction doActionOnTransactions: ', error); 
            //Clear any existing errors
            if(error.status === 409) {
              const errorData = error.errorData;
              if(Array.isArray(errorData) && errorData.length > 0) {
                errorData.forEach( e => {
                  log.setDictionaryMessage(ERRORS.TRANSACTION_REDELIVER_ERROR ,  e.failure); 
                });
              }
            }
            dispatch({type: UPDATE_FAIL, error});
          });
      };

    }

  }
};

export default API;